

import { Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject, Subscription } from 'rxjs';
import { CommonService } from '../../service/common.service';
import { HttpStatusCode } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { FileDocumentDto } from '../../model/file-document-dto';
import { ExaminationService } from 'src/app/examination/examination.service';
import { AdminPermissionDto } from '../../model/admin-permission-dto';
import { ThemeService } from '../../service/colourTheme.service';
import { VideoUploadService } from '../../service/VideoUploadService.service';
import { environment } from 'src/environments/environment';
import { MediaAccessService } from '../../service/media-access.service';
import { FaceDetectionService } from '../../service/face-detection.service';
import * as Sentry from '@sentry/angular';
@Component({
    selector: 'app-web-cam',
    templateUrl: './web-cam.component.html',
    standalone: false
})
export class WebCamComponent implements OnInit, OnChanges, OnDestroy {

  faceValidationMessage: string = '';
  faceModelReady: boolean = false;
  private warmupLoopId: any = null;
  webcamHeight: number = 600;
  webcamWidth: number = 800;

  constructor(private _examinationService: ExaminationService, private _toastr: ToastrService,public _commonService:CommonService , private themeService:ThemeService, private indexedDbService: VideoUploadService, private mediaAccessService: MediaAccessService, public faceDetectionService: FaceDetectionService) { }

  @HostListener('window:resize')
  onResize() {
    this.setWebcamDimensions();
  }

  private setWebcamDimensions(): void {
    const w = window.innerWidth;
    if (w < 480) {
      this.webcamWidth  = 320;
      this.webcamHeight = 240;
    } else if (w < 768) {
      this.webcamWidth  = 480;
      this.webcamHeight = 360;
    } else if (w < 1024) {
      this.webcamWidth  = 560;
      this.webcamHeight = 420;
    } else if (w < 1440) {
      this.webcamWidth  = 640;
      this.webcamHeight = 480;
    } else {
      this.webcamWidth  = 800;
      this.webcamHeight = 600;
    }
  }
  @Output()
  public pictureTaken = new EventEmitter<{ webcamImage: WebcamImage, image: FileDocumentDto }>();
  @Input() ableToAccessCamera: boolean;
  @Input() getAllAdminPermissions:AdminPermissionDto;
  // toggle webcam on/off
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId: string | undefined;
  public videoOptions: MediaTrackConstraints = {
    // width: {ideal: 1024},
    // height: {ideal: 576}
  };
  public errors: WebcamInitError[] = [];
  // latest snapshot
  public webcamImage: WebcamImage;
  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
  enableWebCam: boolean = true;
  private webcamdraftImage:WebcamImage
  userAssessmentDriveSetId:any;
  loading:boolean= false;
  themeBlue:boolean=false;
  isConnectedDrive:boolean = false;
  cameraActive:boolean = false;
  private mediaPermissionSubscription: Subscription;
  public ngOnInit(): void {
    this.themeBlue=this.themeService.isBlueTheme();
    this.enableWebCam = !this.ableToAccessCamera;
    this.setWebcamDimensions();
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });
      this.userAssessmentDriveSetId = sessionStorage.getItem('userAssessmentDriveSetId');
      this.isConnectedDrive = sessionStorage.getItem('connectedDriveId') ? true : false;
      this.mediaAccessService.startContinuousPermissionCheck();
      this.mediaPermissionSubscription = this.mediaAccessService.mediaPermissions$.subscribe(() => {
        this.checkCameraAccess();
      });
      if (this.isFaceDetectionActive()) {
        this.faceDetectionService.loadModel().then(() => {
          this.faceModelReady = true;
          this.startWarmupLoop();
        }).catch(() => {
          this.faceModelReady = true;
        });
      } else {
        this.faceModelReady = true;
      }
  }

  private isFaceDetectionActive(): boolean {
    return this.faceDetectionService.isEnabled() &&
      this.faceDetectionService.shouldRestrictOnFaceDetection(this.getAllAdminPermissions);
  }

  private checkCameraAccess(): void {
    const videoElement = document.querySelector('webcam video') as HTMLVideoElement;
    if (videoElement?.srcObject) {
      const stream = videoElement.srcObject as MediaStream;
      const videoTracks = stream.getVideoTracks();
      if (videoTracks.length > 0 && videoTracks[0].readyState === 'live') {
        this.cameraActive = true;
        return;
      }
    }
    this.cameraActive = false;
  }

  ngOnDestroy(): void {
    if (this.mediaPermissionSubscription) {
      this.mediaPermissionSubscription.unsubscribe();
    }
    this.mediaAccessService.stopContinuousPermissionCheck();
    if (this.warmupLoopId) clearInterval(this.warmupLoopId);
  }

  private startWarmupLoop(): void {
    if (!this.isFaceDetectionActive()) return;
    this.warmupLoopId = setInterval(() => {
      const video = document.querySelector('webcam video') as HTMLVideoElement;
      if (video?.videoWidth) {
        this.faceDetectionService.runSilentInference(video);
      }
    }, 2000);
  }
  ngOnChanges(changes: SimpleChanges): void {

    if (!changes.ableToAccessCamera.currentValue) {
      this.errors.push({message:"Check once again to make sure that is connected and installed properlly",mediaStreamError:null})
      this.enableWebCam = true;
      this.webcamImage = this.webcamdraftImage
    }else{
      this.errors = [];
      this.enableWebCam = false;
    }
  }
  // startWebCam(){
  //   this.enableWebCam=false;
  //   this.showWebcam=true
  //   WebcamUtil.getAvailableVideoInputs()
  //   .then((mediaDevices: MediaDeviceInfo[]) => {
  //     this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
  //   });
  // }

  async triggerSnapshot() {
    this.faceValidationMessage = '';

    // Camera access check
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      stream.getTracks().forEach((track) => track.stop());
    } catch (error: any) {
      if (error.name === 'NotFoundError') {
        this._toastr.error('WebCam is not connected to the device.', 'Info');
        return;
      }
      this._toastr.error('Camera is blocked or not accessible.', 'Info');
      return;
    }

     // Face-in-oval validation
    if (this.isFaceDetectionActive()) {
      const videoElement = document.querySelector('webcam video') as HTMLVideoElement;
      if (!videoElement) {
        this.faceValidationMessage = 'Camera feed not ready. Please wait and try again.';
        this._toastr.warning(this.faceValidationMessage, 'Face Check');
        return;
      }
      const result = await this.faceDetectionService.validateFace(videoElement);
      if (!result.valid) {
        console.log('[FaceCheck] rejected:', { reasonCode: result.reasonCode, message: result.message });
        // reasonCode is the searchable field — several distinct checks share the
        // same candidate-facing message, so message alone can't tell them apart.
        Sentry.logger.warn('Face Check Failed', {
          reasonCode: String(result.reasonCode ?? ''),
          message: result.message,
          driveSetId: String(this.userAssessmentDriveSetId ?? ''),
        });
        this.faceValidationMessage = result.message;
        this._toastr.warning(result.message, 'Face Check');
      return;
      }
    }

    this.trigger.next();
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
  }

  // public handleImage(webcamImage: WebcamImage): void {
  //   console.info('received webcam image', webcamImage);
  //   this.pictureTaken.emit(webcamImage);
  // }
  webCamImageUrl: any;
  imageFile: any
  file: File;
  handleCapturedImage() {
    // this.webcamImage = webcamImage;
    const arr = this.webcamImage.imageAsDataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
      const file: File = new File([u8arr], 'web-cam-image', { type: mime })
      console.log(file);
      this.file = file;
  }
  convertAndDownload(): void {
    // Decode the Base64 string
    const decodedData = atob(this.webcamImage.imageAsBase64);

    // Convert the decoded data to a Uint8Array
    const uint8Array = new Uint8Array(decodedData.length);
    for (let i = 0; i < decodedData.length; i++) {
      uint8Array[i] = decodedData.charCodeAt(i);
    }

    // Create a Blob from the Uint8Array
    const blob = new Blob([uint8Array], { type: 'image/png' });

    // Create a File from the Blob
    const file = new File([blob], 'image.png', { type: 'image/png' });
    this.file = file;
    
    // // Create a download link and trigger the download
    // const link = document.createElement('a');
    // link.href = URL.createObjectURL(file);
    // link.download = 'image.png';
    // link.click();
  }
  private createFileFromBase64(base64DataUrl: string): void {
    const [metadata, base64] = base64DataUrl.split(',');
    const mimeMatch = metadata.match(/:(.*?);/);
    if (!mimeMatch) {
      this._toastr.error('Invalid image format');
      return;
    }
  
    const mime = mimeMatch[1];
  
    const allowedTypes = ['image/jpeg', 'image/png'];
    if (!allowedTypes.includes(mime)) {
      this._toastr.error('Only JPG or PNG images are allowed.');
      return;
    }
  

    const byteString = atob(base64);
    const u8arr = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      u8arr[i] = byteString.charCodeAt(i);
    }
  

    const extension = mime === 'image/jpeg' ? 'jpg' : 'png';
    this.file = new File([u8arr], `web-cam-image.${extension}`, { type: mime });
  
  }

  // public handleImage(webcamImage: WebcamImage): void {
  //   this.enableWebCam = true;
  //   console.info('received webcam image', webcamImage);
  //   this.webcamImage = webcamImage;
  //   this.webCamImageUrl = this.webcamImage.imageAsDataUrl;
  //   this.convertAndDownload();




  //   // this.handleCapturedImage();





  //   // var buffer = new ArrayBuffer(this.webCamImageUrl.length);
  //   // var ba = new Uint8Array(buffer);
  //   // for (var i = 0; i < this.webCamImageUrl.length; i++) {
  //   //   ba[i] = this.webCamImageUrl.charCodeAt(i);
  //   // }
  //   // this.imageFile = new Blob([ba], { type: "image/jpeg" });
  //   // this.file = new File([ba], 'web-cam-image', { type: this.imageFile.type });
  // }
  
  public handleImage(webcamImage: WebcamImage): void {
    this.enableWebCam = true;
    console.info('received webcam image', webcamImage);
    this.webcamImage = webcamImage;
    this.webCamImageUrl = webcamImage.imageAsDataUrl;
  
 
    this.createFileFromBase64(webcamImage.imageAsDataUrl);
  }


  fileData: FileDocumentDto;
  isSaveImagedApiCalled:boolean = false;
 async saveImage() {
    this.loading = true;
    if(this.isSaveImagedApiCalled) {
      return;
    }
    this.isSaveImagedApiCalled = true;
    const formData = new FormData();
    formData.append('file', this.file);

    const imageData = {
      userAssessmentDriveSetId: this.userAssessmentDriveSetId,
      file: this.file,
      timestamp: new Date().toISOString(),
    };

    // await this.indexedDbService.setItem('pendingImages', imageData);

    // if(environment.DESKTOP_IQIGAI_LITE ){
    //   this.saveImageForOflline();
    // }else{
    this._examinationService.saveCaptureImage(this.file, this.userAssessmentDriveSetId).subscribe((response) => {
      if (response && (response.statusCode === HttpStatusCode.Ok || response.status === HttpStatusCode.Ok)) {
        // this._toastr.success('', response['message']);
        this.fileData = response.data as FileDocumentDto;
        if(!this.isConnectedDrive){
          // this.indexedDbService.deleteItem('pendingImages');
        }
        this.pictureTaken.emit({ webcamImage: this.webcamImage, image: this.fileData });
        this.isSaveImagedApiCalled = false;
        this.loading = false;
      } else {
        this.isSaveImagedApiCalled = false;
        this.loading = false;
      }
    })
  // }
  }

  public cameraWasSwitched(deviceId: string): void {
    console.log('active device: ' + deviceId);
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }
  clearImage() {
    this.enableWebCam = false;
    this.webcamImage = null;
    this.faceValidationMessage = '';
  }

  startWebCam() {
    this.enableWebCam = false;
    this.showWebcam = true
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });
  }

  async saveImageForOflline() {

    try {

      this.pictureTaken.emit({ webcamImage: this.webcamImage, image: this.fileData });

      this.loading = false;
    } catch (error) {
      console.error('Error saving image to IndexedDB:', error);
    } finally {
      this.isSaveImagedApiCalled = false;
      this.loading = false;
    }
  }
  
}
